import React, { useEffect } from 'react';
import { StyleSheet, View } from 'react-native';
import { useAppDispatch, useAppSelector } from '../../../redux/store';
import { setAlerts } from '../../../redux/uiSlice';
import { Alert } from './alert';

const Alerts = () => {
	const dispatch = useAppDispatch();
	const errors = useAppSelector(s => s.ui.alerts);

	useEffect(() => {
		let timeout: NodeJS.Timeout | null = null;
		if (errors.length > 0) {
			timeout = setTimeout(() => {
				dispatch(setAlerts([]));
			}, 5000);
		}
		return () => {
			timeout !== null && clearTimeout(timeout);
		};
	}, [errors]);

	const handlePressClose = (id: number) => {
		dispatch(setAlerts(errors.filter((e, i) => i !== id)));
	};

	return (
		<View style={styles.container}>
			{errors.map((error, i) => (
				<Alert
					description={error.description}
					title={error.title}
					variant={error.type}
					key={error.title + i}
					onPressClose={handlePressClose}
					id={i}
				/>
			))}
			{/* <Alert
				title={'Thsii is an error'}
				id={2}
				onPressClose={handlePressClose}
			/> */}
		</View>
	);
};

export default Alerts;

const styles = StyleSheet.create({
	container: {
		position: 'absolute',
		left: 0,
		right: 0,
		zIndex: 9999,
		// backgroundColor: 'white',
		width: '100%',
		height: 'max-content',
	},
});
